<div class="product-catalog-management">
  <div class="header">
    <app-back-button [title]="'module.productCatalogManagement.moduleName' | translate" (backClicked)="gotoDashboard()"> </app-back-button>
  </div>
  <div class="toolbar">
    <mat-form-field class="search">
      <mat-label>{{ 'module.productCatalogManagement.freeTextSearchPlaceholder' | translate }}</mat-label>
      <input matInput type="text" [(ngModel)]="searchParam" (input)="searchValue$.next($event.target.value)" (keydown)="onSearchKeydown($event)" />
      <mat-icon matSuffix (click)="onSearchClick(searchParam)">
        <span class="fa fa-search" aria-hidden="true"></span>
      </mat-icon>
    </mat-form-field>
    <button class="btn btn-outline-primary" (click)="manageLamp()">{{ 'module.productCatalogManagement.addProductButtonText' | translate }}</button>
  </div>

  <div class="body">
    <div class="products">
      <app-lamp-info-card
        class="lamp-product"
        *ngFor="let lamp of catalog$ | async"
        [data]="lamp"
        (selectedLamp)="manageLamp($event)"
        (lampToBeDeleted)="deleteLamp($event)"
      ></app-lamp-info-card>
    </div>
  </div>

  <app-notification-card
    class="app-notification-card"
    *ngIf="!overlayLoaderService.isLoading && maxRowCount === 0"
    type="info"
    text="{{ 'module.productCatalogManagement.currentlyNoDataText' | translate }}"
  >
  </app-notification-card>
</div>
